import { atom } from "recoil";

const GlobalSearchTermAtom = atom({
    key: 'GlobalSearchTermAtomKey',
    default: ''
})

export default GlobalSearchTermAtom;